/**
 * Translates a key with a fallback value if the translation is not found.
 *
 * @param t - The translation function from vue-i18n
 * @param key - The translation key to look up
 * @param fallback - The fallback value to use if translation is not found
 * @param params - Optional parameters to pass to the translation function
 * @returns The translated value or the fallback if translation is not found
 */
export const translateWithFallback = (
  t: (key: string, params?: Record<string, unknown>) => string,
  key: string,
  fallback: string,
  params?: Record<string, unknown>,
): string => {
  const value = t(key, params ?? {});
  return value === key ? fallback : value;
};
